/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import Modal from "react-modal";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";
import { TRestrictRequest } from "apis/meetings/block-request";
import { LoadingModal } from "uis/modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
    width: 454,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1002,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onApproval: (value: string) => Promise<void>;
  data?: TRestrictRequest;
};

const RequestApprovalModal = ({ modalIsOpen, closeModal, onApproval, data }: Props) => {
  const [approvalText, setApprovalText] = useState<string>(data?.requestReason ?? "");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (modalIsOpen) setApprovalText(data?.requestReason ?? "");
  }, [modalIsOpen]);
  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "40px 48px",
          gap: 40,
          borderRadius: 20,
          background: "white",
          position: "relative",
        }}
      >
        <div className="cancel-btn" style={{ position: "absolute", right: 20, top: 20 }}>
          <UI.IconButton.Normal icon="x" size={20} color="var(--alias-color-label-normal)" />
        </div>
        <div className="upper-section" style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <CautionIcon>
            <UI.Icon name="inform" size={56} color="var(--alias-color-status-cautionary)" />
          </CautionIcon>
          <div className="content" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <UI.Typography
              type="heading01"
              fontStyle="bold"
              color="var(--alias-color-label-normal)"
              style={{ textAlign: "center" }}
            >
              "{data?.meetingRoom.name}" 회의실의
              <br />
              예약 제한 요청을 승인하시겠습니까?
            </UI.Typography>
            <UI.Typography
              type="body01 normal"
              color="var(--alias-color-label-alternative)"
              style={{ textAlign: "center" }}
            >
              예약 제한 적용시, 취소되는 일정의 참석자 및 예약 제한 요청자에게 승인 사유가 알림으로 전송됩니다.
            </UI.Typography>
            <UI.Input
              multiline
              placeholder="예) 해당 시간대에 이미 중요한 내부 일정이 있습니다."
              height={212}
              onChange={setApprovalText}
              value={approvalText}
            />
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <UI.Button
            onClick={async () => {
              if (approvalText.length === 0) return;
              if (loading) return;
              setLoading(true);
              await onApproval(approvalText);
              setLoading(false);
            }}
            type="outlined"
            title="승인하기"
            size="large"
            style={{ width: "100%" }}
            disabled={approvalText.length > 0 || loading ? false : true}
          ></UI.Button>
        </div>
      </div>
      <LoadingModal title={"회의실 예약 제한 요청 승인 처리중입니다."} isShowWaitingText={true} modalIsOpen={loading} />
    </Modal>
  );
};

export default RequestApprovalModal;

const CautionIcon = styled.div`
  box-shadow: 0 0 40px 0 rgba(255, 201, 51, 0.42);
  width: 47px;
  height: 47px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
